export default __webpack_public_path__ + "static/media/telegram.d6194584.svg";